// extracted by mini-css-extract-plugin
export default {"container":"SideBar_container__HXPH8","toggleButton":"SideBar_toggleButton__KnGjz","content":"SideBar_content__kxvrn","header":"SideBar_header__IwBtr"};